import React from 'react'


const ServiceAboutSection = ({Data}) => {
    // console.log("serviceabout", Data)
  return (
    <div className='w-full bg-white flex'>
        {/* <div>
            <img src={Data?.about?.aboutimg} alt="" />
        </div>
        <div className='h-1o w-full bg-blue-500'>

        </div> */}
    </div>
  )
}

export default ServiceAboutSection
